import { useDebounceFn } from '@baidu/trade-util';
import { ElTooltip } from 'element-plus';
import { defineComponent, toRefs, ref, computed, onMounted, onUpdated, onUnmounted, resolveComponent, openBlock, createBlock, mergeProps, withCtx, resolveDynamicComponent, normalizeClass, normalizeStyle, createCommentVNode, renderSlot } from 'vue';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.js';

const _sfc_main = defineComponent({
  name: "TEllipsisText",
  components: {
    ElTooltip
  },
  props: {
    line: {
      type: Number,
      default: 1
    },
    contentClass: {
      type: [Object, String, Array],
      default: void 0
    },
    hideImmediately: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: "top"
    },
    popperClass: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    tag: {
      type: String,
      default: "div"
    },
    effect: {
      type: String,
      default: "dark"
    },
    webkit: {
      type: Boolean,
      default: false
    },
    showAfter: {
      type: Number,
      default: void 0
    },
    hideAfter: {
      type: Number,
      default: void 0
    }
  },
  setup(props) {
    const { line } = toRefs(props);
    const contentText = ref("");
    const tooltipDisabled = ref(true);
    const contentDomRef = ref();
    const contentOriginLayout = { width: 0, height: 0 };
    const lineMode = computed(() => {
      return line.value > 1 ? "mutiply" : "single";
    });
    const computeTextOriginLayout = () => {
      const oContent = contentDomRef.value;
      if (oContent) {
        contentText.value = oContent.innerText;
        const range = document.createRange();
        range.setStart(oContent, 0);
        range.setEnd(oContent, oContent.childNodes.length);
        const rangeWidth = range.getBoundingClientRect().width;
        const rangeHeight = range.getBoundingClientRect().height;
        contentOriginLayout.width = rangeWidth;
        contentOriginLayout.height = rangeHeight;
      }
    };
    const { run: computeTextOriginLayoutDebounce } = useDebounceFn(computeTextOriginLayout, { wait: 500 });
    const judgedShouldShowTooltip = () => {
      if (lineMode.value === "mutiply") {
        computeTextOriginLayoutDebounce();
      }
      if (contentDomRef.value) {
        const computedLayout = contentDomRef.value.getBoundingClientRect();
        const { width: currentWith, height: currentHeight } = computedLayout;
        if (parseInt(currentHeight.toString(), 10) < parseInt(contentOriginLayout.height.toString(), 10) || parseInt(currentWith.toString(), 10) < parseInt(contentOriginLayout.width.toString(), 10)) {
          tooltipDisabled.value = false;
        } else {
          tooltipDisabled.value = true;
        }
      }
    };
    const { run: judgedShouldShowTooltipDebounce } = useDebounceFn(judgedShouldShowTooltip, { wait: 500 });
    let contentDomResizeObserver;
    if (ResizeObserver) {
      contentDomResizeObserver = new ResizeObserver(judgedShouldShowTooltipDebounce);
    }
    onMounted(() => {
      computeTextOriginLayout();
      judgedShouldShowTooltip();
      if (contentDomRef.value && contentDomResizeObserver) {
        contentDomResizeObserver.observe(contentDomRef.value);
      } else {
        window.addEventListener("resize", judgedShouldShowTooltipDebounce);
      }
    });
    onUpdated(() => {
      computeTextOriginLayoutDebounce();
      judgedShouldShowTooltipDebounce();
    });
    onUnmounted(() => {
      if (contentDomResizeObserver) {
        contentDomResizeObserver.disconnect();
      } else {
        window.removeEventListener("resize", judgedShouldShowTooltipDebounce);
      }
    });
    return {
      contentText,
      tooltipDisabled,
      lineMode,
      contentDomRef
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  const _component_el_tooltip = resolveComponent("el-tooltip");
  return openBlock(), createBlock(_component_el_tooltip, mergeProps({ content: _ctx.contentText }, _ctx.$attrs, {
    disabled: _ctx.disabled === void 0 ? _ctx.tooltipDisabled : !!_ctx.disabled,
    "show-after": (_a = _ctx.showAfter) != null ? _a : _ctx.hideImmediately ? 0 : void 0,
    "hide-after": (_b = _ctx.hideAfter) != null ? _b : _ctx.hideImmediately ? 0 : void 0,
    placement: _ctx.placement,
    "popper-class": `t-ellipsis-text__tooltip-popper${_ctx.hideImmediately ? " hide-immediately" : ""}${_ctx.popperClass ? ` ${_ctx.popperClass}` : ""}`,
    effect: _ctx.effect
  }), {
    default: withCtx(() => [
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
        ref: "contentDomRef",
        class: normalizeClass([
          "t-ellipsis-text",
          _ctx.lineMode === "mutiply" || _ctx.webkit ? "t-ellipsis-text__mutiply" : "t-ellipsis-text__single",
          _ctx.contentClass
        ]),
        style: normalizeStyle(_ctx.lineMode === "mutiply" || _ctx.webkit ? { WebkitLineClamp: _ctx.line } : void 0)
      }, {
        default: withCtx(() => [
          createCommentVNode(" @slot \u76EE\u524D slot \u5185\u5BB9\u4EC5\u652F\u6301\u4F20\u5165\u6587\u672C\u8282\u70B9 "),
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "style"]))
    ]),
    _: 3
  }, 16, ["content", "disabled", "show-after", "hide-after", "placement", "popper-class", "effect"]);
}
var EllipsisText = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/b2b-fe-repository/trade-ui/packages/components/ellipsis-text/src/ellipsis-text.vue"]]);

export { EllipsisText as default };
//# sourceMappingURL=ellipsis-text.vue2.js.map
